
function NavItem(props) {
  
    return (
      <div className="cursor-pointer">
        <a href="/" class="group relative flex flex-row text-base items-center justify-center gap-2 bg-transparent font-body font-medium text-dark-900 xl:text-lg transition-all duration-300 ease-in-out">
        <div
          className=" w-[22px] h-[22px] invisible group-hover:visible group-hover:opacity-100 group-hover:translate-x-0 translate-x-[-2px] transition-all duration-300 ease-out border-dark-900 hidden md:block">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="22"
            height="22"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="icon icon-tabler icon-tabler-arrow-narrow-right "
          >
            <path stroke="none" d="M0 0h24v24H0z" fill="none" />
            <path d="M5 12h14" />
            <path d="M15 16l4-4" />
            <path d="M15 8l4 4" />
          </svg></div>
          {props.children}</a>
      </div>
    );
  }
  
  export default NavItem;